exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item[data-v-6ea95a56] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n}\n.el-checkbox__input.is-disabled + span.el-checkbox__label[data-v-6ea95a56] {\n  color: #1b91de;\n}\n.el-input.biggest[data-v-6ea95a56] {\n  width: 530px;\n}\n.el-input.big[data-v-6ea95a56] {\n  width: 450px;\n}\n.el-input--small .el-input__inner[data-v-6ea95a56] {\n  width: 300px;\n}\n.el-date-editor.el-input[data-v-6ea95a56], .el-date-editor.el-input__inner[data-v-6ea95a56] {\n  width: 190px;\n}\n.el-checkbox__input.is-disabled + span.el-checkbox__label[data-v-6ea95a56] {\n  color: #1b91de;\n}\n.el-alert[data-v-6ea95a56] {\n  background-color: unset;\n  font-style: normal;\n  text-align: left;\n  display: inline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ea95a56","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TitleConsideration.vue
// module id = G3ah
// module chunks = 1